<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';

export default {
    name: "shopping",
    data() {
        return {
            // list: [
            //     {
            //         image: '',
            //         name: '大苏打阿斯顿阿达a',
            //         price: '33.33',
            //         total_price: '33.33',
            //         length: 1,
            //         isShowDelete: false,
            //     },
            // ],
            // allPrice: '0.00',
            isLoading: false,
            time: null,
        };
    },
    computed: {
        ...mapState(['shoppingData']),
    },
    components: {
        Loading
    },
    mounted() {
        // this.getData();
    },
    destroyed() {},
    watch: {},
    methods: {
        getData() { 
            this.isLoading = true;
            this.$store.dispatch('getShopCart').then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    // this.list = result.data.list.map(v => {
                    //     return {
                    //         ...v,
                    //         // 新增length用于商品数量的显示和修改，count可以在修改失败以后重置length
                    //         length: v.count,
                    //         // 新增isShowDelete用于显示‘确认删除’按钮
                    //         isShowDelete: false,
                    //     }
                    // });
                    // this.allPrice = result.data.total_price;
                } else if (result.code == 90) { 
                    this.toLogin();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
    },
};
</script>

<template>
    <div class="shopping layout_main">
        <p class="title"><router-link to="/shopping">购物车</router-link> · <router-link to="/shopping/order">送货地址</router-link> · 结账</p>
        <div class="vip">
            <p>立即成为 Ambassador<sup>+</sup>会员 可享10%优惠 , 免费参观所有展览，享受学习课程折扣</p>
            <p class="freight_free">订单超过300RMB在中国境内免费送货</p>
        </div>
        <Loading v-if="isLoading"/>
        <!-- 列表 -->
        <div class="wrapper" v-else-if="shoppingData.length > 0">
            <router-view></router-view>
        </div>
        <!--  -->
        <div class="none" v-else>
            <p class="p1">购物车是空的</p>
            <p class="p2">你的购物车里似乎没有物品</p>
            <div class="btn_group flex justify_center">
                <router-link class="btn layout_flex_center" to="/shop">访问商店</router-link>
                <router-link class="btn layout_flex_center" to="/shop/category/22/filter">访问最新</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.shopping{
    padding: .8rem 0;
}
.title{
    font-size: .18rem;
    margin-bottom: .4rem;
    color: #999;
    a{
        &.exact-active{
            color: var(--font_color);
        }
    }
    @media only screen and (max-width: 750px) {
        text-align: center;
        font-size: .36rem;
    }
}
.vip{
    text-align: center;
    font-size: .18rem;
    margin-bottom: .7rem;
    line-height: 1.6;
    .freight_free{
        color: #666;
    }
    @media only screen and (max-width: 750px) {
        font-size: .28rem;
        color: #666;
    }
}
.none{
    text-align: center;
    color: #666;
    @media only screen and (max-width: 750px) {
        min-height: 34vh;
    }
    .p1{
        font-size: .26rem;
        margin-bottom: .6rem;
        @media only screen and (max-width: 750px) {
            font-size: .3rem;
        }
    }
    .p2{
        font-size: .18rem;
        margin-bottom: 1rem;
        @media only screen and (max-width: 750px) {
            font-size: .2rem;
        }
    }
    .btn_group{
        gap: .2rem;
        @media only screen and (max-width: 750px) {
            gap: .3rem;
        }
        .btn{
            width: 2.3rem;
            height: .6rem;
            font-size: .16rem;
            border: 1px solid #999;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
            &::after{
                content: "";
                display: block;
                width: .08rem;
                height: .08rem;
                border-right: 1px solid #666;
                border-top: 1px solid #666;
                transform: rotate(45deg);
                margin-left: .06rem;
            }
        }
    }
}
</style>
<style lang="scss">
.shopping{
    .list{
        .item{
            gap: .4rem;
            padding: .4rem 0;
            border-bottom: 1px solid #999;
            @media only screen and (max-width: 750px) {
                gap: .2rem;
                padding: .3rem 0;
            }
            .cover{
                width: 2rem;
                height: 2.3rem;
                // border: 1px solid #000;
            }
            .content{
                flex: 1;
                padding-top: .2rem;
                .info{
                    font-size: .18rem;
                    color: #666;
                    line-height: 1.8;
                    .name{
                        a{
                            &:hover{
                                border-bottom: 1px solid #666;
                            }
                        }
                    }
                    @media only screen and (max-width: 750px) {
                        font-size: .28rem;
                    }
                }
                .bottom{
                    gap: .4rem;
                    .btn_del{
                        color: #666;
                        font-size: .18rem;
                        cursor: pointer;
                        border-bottom: 1px solid #666;
                        user-select: none;
                        &.confirm{
                            color: var(--font_color);
                            font-weight: bold;
                        }
                    }
                    .price{
                        font-size: .22rem;
                    }
                    @media only screen and (max-width: 750px) {
                        gap: 0;
                        justify-content: space-between;
                        .btn_del{
                            font-size: .26rem;
                        }
                        .price{
                            font-size: .26rem;
                        }
                    }
                }
            }
        }
    }
}
</style>